import React, { useEffect, useState } from 'react'
import './EmployeeAddNew.scss'

import swal from 'sweetalert';
import CryptoJS from 'crypto-js';
import Loader from '../PageStates/Loader';
import Error from '../PageStates/Error';

function EmployeeAddNew() {
	const [pageState, setPageState] = useState(1)
	const [permission, setPermission] = useState(null)

	const [name, setName] = useState('')
	const [address, setAddress] = useState('')
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')

	const [submitButtonState, setSubmitButtonState] = useState(false)

	 useEffect(() => {
				//moment.locale("es");
			  fetch(`${process.env.REACT_APP_BACKEND_ORIGIN}/verifiy_token`, {
				method: 'POST',
				credentials: 'include'
			  })
				.then(async res => {
      const text = await res.text();       // obtenemos la respuesta como texto
      console.log("Respuesta verifiy_token:", text); // log para depurar

      try {
        return JSON.parse(text);           // intentamos parsear a JSON
      } catch (e) {
        console.error("No es JSON válido:", e);
        throw e;
      }
    })

				.then(body => {
				  if (body.operation === 'success') {
					fetch(`${process.env.REACT_APP_BACKEND_ORIGIN}/get_permission`, {
					  method: 'POST',
					  credentials: 'include'
					})
					  .then(res => res.json())
					  .then(body => {
						const p = body.permissions?.find(x => x.page === 'employees');
			
						if (p?.view && p?.create) {
						  setPermission(p);
						} else {
						  window.location.href = '/unauthorized';
						}
					  });
				  } else {
					window.location.href = '/login';
				  }
				})
				.catch(console.log);
			}, [])
			useEffect(() => {
					if (permission !== null) {
						setPageState(2);
					}
				}, [permission])

	const insertEmployee = async () => {
		if (name === "") {
			swal("¡Ups!", "El nombre no puede estar vacío", "error")
			return;
		}

		if (email === "") {
			swal("¡Ups!", "El correo no puede estar vacío", "error")
			return;
		}

		let regex = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-z]+)$/;
		if (!regex.test(email)) {
			swal("¡Ups!", "Por favor ingresa un correo válido", "error")
			return;
		}

		if (password === "") {
			swal("¡Ups!", "La contraseña no puede estar vacía", "error")
			return;
		}

		let obj = {}
		obj.name = name;
		obj.address = address;
		obj.email = email;
		obj.password = CryptoJS.AES.encrypt(password, process.env.REACT_APP_CRYPTOJS_SEED).toString();

		setSubmitButtonState(true)

		let response = await fetch(`${process.env.REACT_APP_BACKEND_ORIGIN}/add_employee`, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json; charset=UTF-8'
			},
			body: JSON.stringify(obj),
			credentials: 'include',
		})
		let body = await response.json()

		setSubmitButtonState(false)

		if (body.operation === 'success') {
			console.log('Empleado agregado correctamente')
			swal("¡Éxito!", "Empleado agregado correctamente", "success")

			setName('')
			setAddress('')
			setEmail('')
			setPassword('')
		} else {
			swal("¡Ups!", body.message, "error")
		}
	}

	return (
		<div className='employeeaddnew'>
			<div className='employee-header'>
				<div className='title'>Agregar nuevo empleado</div>
				{/* breadcrumb */}
			</div>

			{
				pageState === 1 ?
					<Loader />
					: pageState === 2 ?
						<div className="card">
							<div className="container" style={{ display: "flex", flexDirection: "column" }}>

								<div style={{ display: "flex", justifyContent: "space-evenly" }}>
									<div className="right" >
										<div className="row" style={{ display: 'flex', marginTop: "0.5rem" }}>
											<div className='col'>
												<label className='fw-bold'>Nombre</label>
												<input
													className='my_input'
													type='text'
													value={name}
													onChange={(e) => { setName(e.target.value) }}
												/>
											</div>
											<div className='col'>
												<label className='fw-bold'>Dirección</label>
												<input
													className='my_input'
													type='text'
													value={address}
													onChange={(e) => { setAddress(e.target.value) }}
												/>
											</div>
										</div>

										<div className="row" style={{ display: 'flex', marginTop: "0.5rem" }}>
											<div className='col'>
												<label className='fw-bold'>Correo</label>
												<input
													className='my_input'
													type='email'
													value={email}
													onChange={(e) => { setEmail(e.target.value) }}
												/>
											</div>
											<div className='col'>
												<label className='fw-bold'>Contraseña</label>
												<input
													className='my_input'
													type='password'
													value={password}
													onChange={(e) => { setPassword(e.target.value) }}
												/>
											</div>
										</div>
									</div>
								</div>

								{
									permission.create &&
									<button
										className='btn success'
										style={{ alignSelf: "center", marginTop: "1rem" }}
										disabled={submitButtonState}
										onClick={() => { insertEmployee() }}
									>
										{!submitButtonState
											? <span>Guardar</span>
											: <span><div className="button-loader"></div></span>
										}
									</button>
								}
							</div>
						</div>
						:
						<Error />
			}
		</div>
	)
}

export default EmployeeAddNew
